import getTemplate from 'Components/ActionsPage/templates'
import call_without_file from 'Images/call_without_file.svg'
import generate_file from 'Images/generate_file.svg'
import select_node from 'Images/select_node.svg'
import upload_file from 'Images/upload_file.svg'

export pluginStatuses = {
  ERRORED: 'error'
  INIT: 'info'
  PROGRESS: 'info'
  DONE: 'success'
  PENDING: 'warning'
}

backwardsCompatibleGet = (node, attrKey)  ->
  # TODO: Remove this once we have migrations.
  try
    node.get(attrKey)
  catch
    node[attrKey]

export getDefaultDescription = (actionsPage) ->
  switch backwardsCompatibleGet(actionsPage, 'serviceCall')
    when 'import'
      "This action imports data into Weaver."
    when 'transformFromFile'
      "This action performs a transformation on the data in the space."
    when 'export'
      "This action exports data from Weaver."
    when 'train'
      "This action starts Machine Learning training."
    when 'getStatus'
      "This action allows you to get the Machine Learning status."
    when 'predict'
      "This action allows for Machine Learning predictions."
    else
      "There is no description for this Service"

export getComponentIcon = (component) ->
  imgRegistry = {
    call_without_file
    generate_file
    select_node
    upload_file
  }

  imgRegistry[component] or call_without_file

export templateRegistry = [
  'generate_file'
  'generate_file_from_branch'
  'call_without_file'
  'simple'
  'upload_file'
  'upload_file_to_branch'
  'select_node'
  'upload_transformations_file'
  'train_ml'
  'predict_ml'
  'status_ml'
  'sync_project'
  'json_editor'
]

export getTemplateInputs = (key) ->
  switch key
    when 'upload_file'
      ['file']
    when 'upload_file_to_branch'
      ['file', 'branch']
    when 'upload_transformations_file'
      ['file']
    when 'select_node'
      ['nodeId']
    when 'json_editor'
      ['json']
    when 'sync_project'
      ['fromProject', 'toProject', 'fromBranch', 'toBranch']
    when 'generate_file_from_branch'
      ['branch']
    else
      []

export doesTemplateExist = (key) ->
  try
    getTemplate(key)?
